module.exports = __webpack_public_path__ + "static/media/redHat.2e5c1f8b.textClipping";